var LINK_ROUTE_DISTANCE_THRESHOLD = 10;

export const transformMatrix = (matrix, deg) => {
  var ret = [];
  matrix.forEach(node => {
    var xRotated = node.x * Math.cos(deg) + node.y * Math.sin(deg);
    var yRotated = -node.x * Math.sin(deg) + node.y * Math.cos(deg);
    ret.push({
      xRotated: xRotated,
      yRotated: yRotated,
      x: node.x,
      y: node.y,
      w: node.w,
      h: node.h
    });
  });
  return ret;
};

export const distance = (a, b) => {
  return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
};

export const makeId = (graph, external) => {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};

export const closestDot = (rect, markedSteps) => {
  return markedSteps.filter(s => {
    return distance(rect, s) < LINK_ROUTE_DISTANCE_THRESHOLD;
  })[0];
};

export const collides = (grid, x, y) => {
  var isCollision = false;
  for (var i = 0, len = grid.length; i < len; i++) {
    var left = grid[i].xRotated,
      right = grid[i].xRotated + grid[i].w;
    var top = grid[i].yRotated,
      bottom = grid[i].yRotated + grid[i].h;
    if (right >= x && left <= x && bottom >= y && top <= y) {
      isCollision = grid[i];
    }
  }
  return isCollision;
};

export const getRoutePoints = vertices => {
  var waypoints = [];
  for (var i = 1; i < vertices.length; i++) {
    var pt0 = vertices[i - 1];
    var pt1 = vertices[i];
    var dx = pt1.x - pt0.x;
    var dy = pt1.y - pt0.y;
    var density = distance(pt0, pt1) / 10;
    for (var j = 0; j < density; j++) {
      var x = pt0.x + dx * (j / density);
      var y = pt0.y + dy * (j / density);
      waypoints.push({ x: x, y: y });
    }
  }
  return waypoints;
};
/*
export const gridToPathGrid = (grid, w, h, p) => {
  var ret = []; // {1, 0, 0, 0, 1}
  grid.map(loc => {
    if (loc.x + p < w) ret.push([loc.x, loc.y, loc.x + 10, loc.y, 0]);
    if (loc.x - p > 0) ret.push([loc.x, loc.y, loc.x - 10, loc.y, 0]);
    if (loc.y + p < h) ret.push([loc.x, loc.y, loc.x, loc.y + 10, 0]);
    if (loc.y - p > 0) ret.push([loc.x, loc.y, loc.x, loc.y - 10, 0]);
    if (loc.x + p < w && loc.y + p < h)
      ret.push([loc.x, loc.y, loc.x + 10, loc.y + 10, 0]);
    if (loc.x + p < w && loc.y - p > 0)
      ret.push([loc.x, loc.y, loc.x + 10, loc.y - 10, 0]);
    if (loc.x - p > 0 && loc.y - p > 0)
      ret.push([loc.x, loc.y, loc.x - 10, loc.y - 10, 0]);
    if (loc.x - p > 0 && loc.y + p < h)
      ret.push([loc.x, loc.y, loc.x - 10, loc.y + 10, 0]);
  });
  return ret;
};*/


// WEBPACK FOOTER //
// src/utils/calc.js